import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m6 11-2.08 1.56c-.704.527-1.056.791-1.31 1.126a3 3 0 0 0-.495.99C2 15.079 2 15.52 2 16.399V20l4-1m12-8 2.08 1.56c.704.529 1.056.793 1.31 1.127.225.296.392.632.495.99.115.403.115.844.115 1.723V20l-4-1m-6 3v-3M14 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM8.739 4.02l-.687.636c-.756.7-1.134 1.05-1.405 1.466a4 4 0 0 0-.525 1.203C6 7.806 6 8.322 6 9.352V16c0 1.864 0 2.796.304 3.53a4 4 0 0 0 2.165 2.165C9.204 22 10.136 22 12 22v0c1.864 0 2.796 0 3.53-.305a4 4 0 0 0 2.165-2.164C18 18.796 18 17.864 18 16V9.352c0-1.03 0-1.546-.122-2.027a4.002 4.002 0 0 0-.525-1.203c-.27-.416-.649-.766-1.405-1.466l-.687-.636c-1.15-1.065-1.724-1.597-2.378-1.799a3 3 0 0 0-1.766 0c-.654.202-1.228.734-2.378 1.799Z"
    />
  </svg>
)
export default SvgComponent
